export { parseTime, formatTime } from '@/utils';

/**
 * 企业经营状态
 */
export function companyOperationStateName(number) {
    if (number === 5 || number === '5') {
        return '存续';
    }
    if (number === 7 || number === '7') {
        return '在业';
    }
    if (number === 4 || number === '4') {
        return '吊销';
    }
    if (number === 0 || number === '0') {
        return '注销';
    }
    if (number === 1 || number === '1') {
        return '撤销';
    }
    if (number === 6 || number === '6') {
        return '迁出';
    }
    if (number === 2 || number === '2') {
        return '停业';
    }
    if (number === 8 || number === '8') {
        return '已告解散';
    }
    if (number === 3 || number === '3') {
        return '其他';
    }
    return '';
}

/**
 * 综合实力评级
 */
export function comprehensiveStrengthGradeName(number) {
    if (number === 0 || number === '0') {
        return 'A';
    }
    if (number === 1 || number === '1') {
        return 'B';
    }
    if (number === 2 || number === '2') {
        return 'C';
    }
    if (number === 3 || number === '3') {
        return 'D';
    }
    if (number === 4 || number === '4') {
        return 'E';
    }
    return '——';
}

/**
 * 融资类型
 */
export function financingName(number) {
    if (number === 0 || number === '0') {
        return '种子轮';
    }
    if (number === 1 || number === '1') {
        return '天使轮';
    }
    if (number === 2 || number === '2') {
        return 'A轮';
    }
    if (number === 3 || number === '3') {
        return 'B轮';
    }
    if (number === 4 || number === '4') {
        return 'C轮';
    }
    if (number === 5 || number === '5') {
        return 'D轮';
    }
    if (number === 6 || number === '6') {
        return 'E轮～Pre-IPO';
    }
    if (number === 7 || number === '7') {
        return '战略投资';
    }
    if (number === 8 || number === '8') {
        return '并购';
    }
    if (number === 9 || number === '9') {
        return '新三板';
    }
    if (number === 10 || number === '10') {
        return 'IPO上市及以后';
    }
    return '';
}

/**
 * 专利类型
 */
export function patentTypeName(number) {
    if (number === 0 || number === '0') {
        return '发明';
    }
    if (number === 1 || number === '1') {
        return '实用新型';
    }
    if (number === 2 || number === '2') {
        return '外观';
    }
    return '';
}

/**
 * 专利法律状态
 */
export function patentLegalState(number) {
    if (number === 0 || number === '0') {
        return '在审';
    }
    if (number === 1 || number === '1') {
        return '授权';
    }
    if (number === 2 || number === '2') {
        return '失效';
    }
    return '';
}

export function amountTenThousand(num, type) {
    if (num) {
        return `${(num / 10000).toLocaleString()}万${currencyName(type)}`;
    }
    return '未披露';
}

/**
 * 货币类型
 */
export function currencyName(type) {
    if (type === 'CNY') {
        return '人民币';
    }
    if (type === 'USD') {
        return '美元';
    }
    if (type === 'HKD') {
        return '港元';
    }
    if (type === 'EUR') {
        return '欧元';
    }
    if (type === 'JPY') {
        return '日元';
    }
    if (type === 'AFN') {
        return '阿富汗尼';
    }
    if (type === 'AUD') {
        return '澳大利亚元';
    }
    if (type === 'FRF') {
        return '法国法郎';
    }
    if (type === 'CAD') {
        return '加元';
    }
    if (type === 'DEM') {
        return '德国马克';
    }
    if (type === 'CLP') {
        return '智利比索';
    }
    if (type === 'SGD') {
        return '新加坡元';
    }
    if (type === 'GBP') {
        return '英镑';
    }
    if (type === 'CHF') {
        return '瑞士法郎';
    }
    if (type === 'DKK') {
        return '丹麦克朗';
    }
    if (type === 'MOP') {
        return '澳门币';
    }
    return '';
}

/**
 * 证书状态
 */
export function certificateStatus(number) {
    if (number === 1 || number === '1') {
        return '有效';
    }
    if (number === 2 || number === '2') {
        return '注销';
    }
    if (number === 3 || number === '3') {
        return '过期';
    }
    if (number === 4 || number === '4') {
        return '暂停';
    }
    if (number === 5 || number === '5') {
        return '撤销';
    }
    if (number === 6 || number === '6') {
        return '失效';
    }
    if (number === 7 || number === '7') {
        return '未知';
    }
    return '——';
}

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
    if (time === 1) {
        return time + label;
    }
    return `${time + label}s`;
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
    const between = Date.now() / 1000 - Number(time);
    if (between < 3600) {
        return pluralize(~~(between / 60), ' minute');
    }
    if (between < 86400) {
        return pluralize(~~(between / 3600), ' hour');
    }
    return pluralize(~~(between / 86400), ' day');
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
    const si = [
        { value: 1e18, symbol: 'E' },
        { value: 1e15, symbol: 'P' },
        { value: 1e12, symbol: 'T' },
        { value: 1e9, symbol: 'G' },
        { value: 1e6, symbol: 'M' },
        { value: 1e3, symbol: 'k' },
    ];
    for (let i = 0; i < si.length; i++) {
        if (num >= si[i].value) {
            return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
        }
    }
    return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
    return (+num || 0).toString().replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * 获取枚举值,list格式：[{label:'名称',value:'值'}]
 * @param value {Object}
 * @param list {Array}
 * @returns {string|*}
 */
export function getText(value, list) {
    if (value === null || value === '') {
        return '';
    }

    for (let i = 0; i < list.length; i++) {
        if (String(value) === String(list[i].value)) {
            return list[i].text;
        }
    }
}

/**
 * 字段值
 */
export function getDictName(value, arr) {
    if (value === undefined) return '';
    let name = '';
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === value) {
            name = arr[i].text;
        }
    }
    return name;
}



// WEBPACK FOOTER //
// ./src/filters/index.js